import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '@shared-angular/services/login.service';
import { ReflactTrainAuthService } from '@shared-angular/services/reflact-train-auth.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { UsertokenService } from '@shared-angular/services/usertoken.service';

@Component({
  selector: 'app-reflact-train-auth',
  imports: [],
  template: ''
})
export class ReflactTrainComponent {

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authService = inject(ReflactTrainAuthService);
  private usertokenService = inject(UsertokenService);
  private loginService = inject(LoginService);
  private toastr = inject(ToastrService);

  constructor() {
    this.route.queryParams.subscribe(async (params) => {
      const { access_token: token, state } = params as { access_token?: string, state?: string };
      if (!token || !state) {
        console.error('Invalid reflact Train auth callback request', params);
        void this.router.navigate(['/']);
        return;
      }

      let mcpId: string, path: string;
      try {
        ({ mcpId, path } = JSON.parse(this.fromBase64(state)) as { mcpId: string, path: string });
      } catch (_error) {
        console.error('Invalid reflact Train auth state', state);
        void this.router.navigate(['/']);
        return;
      }

      // Als Popup-Fenster geoeffnet -> Ergebnis nur an das oeffnende Fenster melden, nicht selbst verarbeiten/navigieren.
      const opener = window.opener as Window | null;
      if (opener) {
        opener.postMessage({ type: 'reflactTrainAuthCallback', token, mcpId }, window.location.origin);
        window.close();
        return;
      }

      try {
        const result = await this.authService.authorizeReflactTrain({ token, mcpId });
        if (result.token) {
          this.usertokenService.setUserTokenAfterAuth(result.token);
          await this.loginService.loadMyUser();
        }
        window.location.href = window.location.origin + '/' + window.location.pathname.split("/")[1] + "/" + decodeURIComponent(path);
      } catch (_error) {
        console.error(_error);
        this.toastr.error("ERROR_403", $localize`:@@failed-to-authenticate-reflact-train:Fehler beim Authentifizieren bei reflact Train. Versuche es später erneut.`);
      }
    });
  }

  private fromBase64(b64: string): string {
    const binary = atob(b64);
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  }

}
